<template>
  <div id="app">

    <AppNavbar style="display:none;" />
    <div class="containerrrr">

      <!-- <DesktopNavbarShadow v-if="1>2" /> -->
      <div style="height:1px; width:100px;"></div>

      <div class="app-content">
        <router-view />
      </div>
      <OnlyFooter />
    </div>
    <PModal />

  </div>


</template>

<script>
import AppNavbar from './components/navbar/AppNavbar.vue'
import OnlyFooter from './components/OnlyFooter.vue'

import PModal from './views/parking/PModal.vue'
// import DesktopNavbarShadow from '@/components/navbar/DesktopNavbarShadow.vue';


export default {
  name: 'App',
  components: {

    AppNavbar,
    OnlyFooter,
    PModal,
  },
  mounted() {
    this.handleResize(); // Apply initial scaling
    window.addEventListener('resize', this.handleResize); // Add resize event listener

    console.log("google map api key is ", process.env.VUE_APP_GOOGLE_MAPS_API_KEY);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize); // Remove event listener
  },
  methods: {
    handleResize() {
      let appContent = this.$el.querySelector('.containerrrr'); // Target the content area
      // const viewportWidth = window.innerWidth;
      const viewportWidth = document.documentElement.clientWidth;
      // console.log('viewportWidth', viewportWidth);

      if (viewportWidth >= 560 && viewportWidth <= 1464) {
        // Calculate scale proportional to viewport width
        // const alpha = 560/1200.0;
        // const scale = (1-alpha) + (viewportWidth - 560) / (1200 - 560) * (alpha);
        const scale = viewportWidth / 1464.0;

        appContent.style.width = '1465px';

        

        // console.log('viewportWidth', viewportWidth, 'scale:', scale);
        appContent.style.transform = `scale(${scale})`;
        // appContent.style.transformOrigin = 'top center'; // Scale from the top center
        appContent.style.transformOrigin = "left top";
        // appContent.style.transformOrigin = 0;

        //adjust the height of appContent to fill the screen
        appContent.style.height = '100vh'/scale;

      } else if (viewportWidth < 560) {
        // Fixed scale for small screens
        appContent.style.width = '100%';

        appContent.style.transform = 'scale(1)';
        appContent.style.transformOrigin = 'top center';
      } else {
        // Reset scaling for large screens
        appContent.style.width = '100%';

        appContent.style.transform = 'scale(1)';
        appContent.style.transformOrigin = 'top center';
      }


      // appContent = this.$el.querySelector('.navbarrr'); // Target the content area
      // // const viewportWidth = window.innerWidth;
      // // const viewportWidth = document.documentElement.clientWidth;

      // if (viewportWidth >= 560 && viewportWidth <= 1464) {
      //   // Calculate scale proportional to viewport width
      //   // const alpha = 560/1200.0;
      //   // const scale = (1-alpha) + (viewportWidth - 560) / (1200 - 560) * (alpha);
      //   const scale = viewportWidth / 1464.0;

      //   appContent.style.width =  '1465px';

      //   // console.log('viewportWidth', viewportWidth, 'scale:', scale);
      //   appContent.style.transform = `scale(${scale})`;
      //   // appContent.style.transformOrigin = 'top center'; // Scale from the top center
      //   appContent.style.transformOrigin = "left top";
      //   // appContent.style.transformOrigin = 0;

      // } else if (viewportWidth < 560) {
      //   // Fixed scale for small screens
      //   appContent.style.width =  '100%';

      //   appContent.style.transform = 'scale(1)';
      //   appContent.style.transformOrigin = 'top center';
      // } else {
      //   // Reset scaling for large screens
      //   appContent.style.width =  '100%';

      //   appContent.style.transform = 'scale(1)';
      //   appContent.style.transformOrigin = 'top center';
      // }


    },
  },
};
</script>

<style>
/* Global styles */
html {
  scroll-behavior: smooth;
  font-size: 100%;
  /* Default font size (16px) */
  box-sizing: border-box;

  width: 100%;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  text-align: center;
  color: #2c3e50;
  margin-top: 0;
  padding: 0;
  /* width: 100%; */
  width: 100%;
  height: 50vh;
  background-color: var(--background-gray);

  /* display:flex; */
  /* flex:1; */
  position: relative;
  /* Full width for responsiveness */
}

.containerrr {
  width: 100%;
  /* Full width */
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f5f5f5;
  /* Light gray background */
  padding: 0;
  margin: 0;
}

/* Ensure the content area scales proportionally */
.app-content {
  width: 100%;
  /* Full width */
  transition: transform 0.3s ease;
  /* Smooth transition for scaling */
}
</style>
